
import { ChevronLeft, Download, Loader2, X, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DocumentHeaderProps {
  onBack: () => void;
  onDownload: () => void;
  onApprove: () => void;
  onReject: () => void;
  status: string;
  documentUrl: string | null;
  isUpdating: boolean;
}

export function DocumentHeader({ 
  onBack, 
  onDownload, 
  onApprove, 
  onReject, 
  status, 
  documentUrl, 
  isUpdating 
}: DocumentHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <Button variant="ghost" onClick={onBack} className="mb-2 sm:mb-0 -ml-2">
        <ChevronLeft className="mr-2 h-4 w-4" />
        Back to Documents
      </Button>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onDownload} disabled={!documentUrl}>
          <Download className="mr-2 h-4 w-4" />
          Download
        </Button>
        {status === 'pending' && (
          <>
            <Button 
              variant="destructive" 
              onClick={onReject}
              disabled={isUpdating}
            >
              {isUpdating ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <X className="mr-2 h-4 w-4" />}
              Reject
            </Button>
            <Button 
              onClick={onApprove}
              disabled={isUpdating}
            >
              {isUpdating ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Check className="mr-2 h-4 w-4" />}
              Approve
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
